import { useEffect, useState } from 'react'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { GenericDataTable } from 'helpers/generic-data-table'
import { matchesColumns } from 'helpers/match-columns'
import { Loader } from 'lucide-react'
import {
  deleteMatch,
  fetchMatches,
  setMatchResult,
  updateMatch,
} from 'store/matches/matchesSlice'
import { useAppDispatch, useAppSelector } from 'store/store'

export const MatchesPage = () => {
  const dispatch = useAppDispatch()
  const { loading, error, matches, totalPages } = useAppSelector(
    (state) => state.matches
  )
  const [pageIndex, setPageIndex] = useState(0) // React Table uses 0-based index
  const pageSize = 20

  useEffect(() => {
    dispatch(fetchMatches(pageIndex + 1))
  }, [dispatch, pageIndex])

  let content = <Loader className='h-5 w-5 animate-spin' />
  if (!loading) {
    if (error) {
      content = <p className='uk-text-danger'>Errore: {error}</p>
    } else if (matches) {
      content = (
        <>
          <GenericDataTable
            columns={matchesColumns({
              onSetMatchResult: (matchId, result) => {
                dispatch(setMatchResult({ matchId, result }))
              },
              onUpdateMatch: (match) => {
                dispatch(updateMatch(match))
              },
              onDeleteMatch: (matchId) => {
                if (
                  window.confirm(
                    'Sei sicuro di voler eliminare questa partita?'
                  )
                ) {
                  dispatch(deleteMatch(matchId))
                }
              },
            })}
            data={matches || []}
            pageCount={totalPages}
            pageIndex={pageIndex}
            pageSize={pageSize}
            onPageIndexChange={setPageIndex}
          />
        </>
      )
    }
  }

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Match</h2>
            <p className='text-muted-foreground'>Pagina di gestione match</p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          {content}
        </div>
      </Main>
    </>
  )
}

export default MatchesPage
